export default function Switch(props) {
    const {value, children} = props
    return children.find(child => {
        return child.props.value === value
    })
}